import { getRenderTimeMs, isServerRendering } from "~/lib/ssr/runtime";
import type { AppRouterContext } from "~/lib/router-runtime";
import type { RwaCategoryId } from "./registry";

export function createRwaMarketsRouteLoader(categoryId: RwaCategoryId) {
  return ({
    context,
    preload,
  }: {
    readonly context: AppRouterContext;
    readonly preload?: boolean;
  }) => {
    const queryTimeMs = getRenderTimeMs();
    const warm = import("./rwa-markets-route")
      .then(async ({ preloadRwaMarketsRoute }) => {
        await preloadRwaMarketsRoute(context, categoryId, {
          nowMs: queryTimeMs,
        });
      })
      .catch(() => {
        // A stale deploy chunk is recovered by the global vite:preloadError
        // handler. Keep intent preloads from also emitting unhandledrejection.
      });
    // The first browser render must use the publisher's UTC window, including
    // when a cached document is opened across midnight. SPA warming stays nonblocking.
    if (isServerRendering() || preload)
      return warm.then(() => ({ queryTimeMs }));
    void warm;
    return { queryTimeMs };
  };
}
